export default ['api', 'availabilityCacheService', (api, availabilityCacheService) => {
    const switchEventType = (eventType) => {
        switch (eventType.toLowerCase()) {
            case 'treatment':
                return 'treatments';
            case 'day':
            case 'spaday':
            case 'spa day':
                return 'spa-days';
            default:
                return null;
        }
    };

    const uncacheDate = (eventType, eventId, date) => availabilityCacheService.uncacheDate(eventType, eventId, date);

    const requestAvailability = (fromDate, toDate, eventType, eventId, offerId = null) => {
        let cached = availabilityCacheService.datesCached(eventType, eventId, fromDate, toDate);

        if (cached.length) {
            return Promise.resolve(cached);
        }

        let url = `/api/${api.property()}/${switchEventType(eventType)}/${eventId}/availability?from_date=${fromDate}&to_date=${toDate}`;

        if (offerId) {
            if (typeof offerId === 'object') {
                offerId = offerId.id;
            }
            url += `&offer_id=${offerId}`;
        }

        return api.get(url).then(response => {
            availabilityCacheService.updateCache(eventType, eventId, response.data);
            return response.data;
        });
    };

    const requestAvailabilityList = (date, eventType, eventIds = null, offerId = null) => {
        let url = `/api/${api.property()}/${switchEventType(eventType)}/availability?date=${date}`;

        if (eventIds) {
            url += `&event_ids=${eventIds.join(',')}`;
        }

        if (offerId) {
            url += `&offer_id=${offerId}`;
        }

        return api.get(url).then(response => response.data);
    };

    return {
        switchEventType,
        uncacheDate,
        requestAvailability,
        requestAvailabilityList
    };
}];



// WEBPACK FOOTER //
// ./frontend/admin/app/modules/basket/services/availability.api.service.js